export default "__VITE_ASSET__Df6X6EDw__"